module.exports = __webpack_public_path__ + "static/back_0-1e67865870c7dc564fea66ae0ed725c9.svg";